import { API_CONFIG } from 'shared/constants/constants';
import { Action } from 'shared/interface';
import httpService from 'shared/services/http.service';
import { createAction } from 'shared/util/utility';
import * as actionTypes from 'store/action-types';

const fetchBaseCount = (dispatch: (action: Action) => void) => {
	httpService
		.get(API_CONFIG.path.alertBaseCount)
		.then((response) => {
			dispatch(createAction(actionTypes.UPDATE_ALERT_COUNT, response));
		})
		.catch((err) => console.error('error', err));
};

export { fetchBaseCount };
